export enum SearchItemType {
  RULE = 'Rule',
  PACKAGE = 'Package',
  DOCKET = 'Docket',
  SUPPLEMENT = 'Supplement',
  ARTICLE = 'Article',
  INDEX = 'Index'
}
export enum SuggestionType {
  Other = 99,
  Synonym = 1,
  History = 2,
  Heading = 3,
  Keyword = 4,
  Note = 5
}

export enum PublicationType {
  Docket,
  Disposition,
  Supplement,
  Index,
  PublicDisposition,
  RulesAndSpecifications,
  ExplanationOfAbbreviations,
  CarrierProcedures
}

export interface ItemDetail {
  itemNumber: string;
  groupingHeading: string;
  grouping: string;
  itemSubItems?: ArticleSubItem[];
  description: {
    descriptionText: string;
  };
}

export interface ArticleDescriptionLine {
  indent: string;
  text: string;
}
export interface ArticleSubItem {
  item: string;
  description: string;
  classification: string;
  descriptionHtml: string;
}

export interface Article {
  itemNumber: string;
  classification: string
  groupingItemNumber: string;
  groupingHeading: string;
  headingHtml: string
  descriptionLines: ArticleDescriptionLine[];
  subItems?: ArticleSubItem[];
  descriptionText: string;
  descriptionHtml: string;
  isFavorite: boolean;
  headingDataAbove: boolean;
  headingDataBelow: boolean;
  isUpdateFavorite: boolean;
  grouping?: Grouping;
  firstOrLast: number;
}
export interface Grouping {
  headingNumber?: string;
  html?: string;
  isFavorite: boolean;
  subHeadingNumber?: string;
  subHeadingHtml?: string;
  hierarchy?: hierarchy[];
  isSubFavorite: boolean;
}
export enum ResultRowType {
  Group = 'group',
  Article = 'article',
  Sub = 'sub',
  Note = 'note',
  More = 'more',
  MoreGroup = 'moreGroup'
}
export interface hierarchy {
  number: string;
  fullText: string;
  html: string;
}
export interface ResultRow {
  item: string;
  article: string;
  groupingHeading: string;
  groupingHeadingNumber: string;
  descriptionLines?: ArticleDescriptionLine[];
  descriptionText?: string;
  descriptionHtml?: string;
  class?: number | string;
  isSearchMatch?: boolean;
  type: ResultRowType;
  itemNumber?: string;
  isFavorite?: boolean;
  isUnderHeading: boolean;
}
export interface SearchSuggestion {
  suggestion: SuggestionItem[];
  isNumber: boolean;
  hasMore: boolean;
}
export interface SuggestionItem {
  itemNumber: string;
  description: string;
  resultType: SuggestionType;
}

export interface SearchRequest {
  itemNumber?: string;
  terms: string;
  type: string;
  filters: {
    contentDate?: string | null;
    supplementDateFrom?: string | null;
    supplementDateTo?: string | null;
    supplement?: string | null;
    docket?: string | null;
  },
  page?: number;
  pageSize?: number;
}
export interface ItemDetailRequest {
  itemNumber: string;
  type: string;
  contentDate?: string | null;
}

export interface BasicSearchResponse {
  totalMatched: number;
  searchHints: string;
  articles: Article[];
  searchedTerms: SearchTerms[];
}

export interface SearchTerms {
  term: string;
  type: string;
}

export interface SuggestionsResponse {
  suggestions: SuggestionItem[];
  moreThanMax: boolean;
  isTermNumber: boolean;
  searchedTerms: SearchTerms[];
}

export interface SearchResultList {
  index: number;
  label: string;
  count: number;
  ariaLabel: string;
  columnNames: string[];
  items: DetailSearchItem[];
  grouping?: SearchResultArticleGrouping[];
}
export interface SearchResultArticleList {
  index: number;
  label: string;
  count: number;
  ariaLabel: string;
  columnNames: string[];

}
export interface SearchResultArticleGrouping {
  key: string;
  value: DetailSearchItem[];
}
// export interface SearchResultItem {
//   groupHeading: string;
//   itemNumber: string;
//   description: string;
// }

export interface FilterSupplement {
  id: string;
  text: string;
}

export interface FilterDocket {
  id: string;
  text: string;
}


export interface FilterSupplement {
  id: string;
  text: string;
}

export interface PublicDocket {
  id: string;
  text: string;
}


export interface DetailedSearchResponse {
  data: DetailedSearch;
}

export interface DetailedSearch {
  articles?: DetailSearchResult;
  indexs?: DetailSearchResult;
  rules?: DetailSearchResult;
  packages?: DetailSearchResult;
  supplements?: DetailSearchResult;
  dockets?: DetailSearchResult;
  carriers?: DetailSearchResult;
  totalMatched: number;
  searchedTerms: SearchTerms[];
  selectedListIndex: number;
  displayMobileResultsPanel: boolean;
}

export interface DetailSearchResult {
  index: number;
  label: string;
  count: number;

  listColumnNames: ['Article', 'Item'],
  items: DetailSearchItem[];
}

export interface DetailSearchItem {
  itemNumber: string;
  itemNumbers: string[];
  groupHeading: string;
  description: string;
  subDescription?: string;
  isCanceledReference: boolean;
  canceledItemNumber?: string;
  publicationId?: string;
  pageNumber?: number;
  isGrouping: boolean;
  effectiveDate?: string;
}

export interface ItemSelectedEventObject {
  itemNumber: string;
  name: string;
}

export interface HeaderItemsRequest {
  itemNumber: string;
  isAbove: boolean;
  contentDate?: string;
  isUnderHeading: boolean;
}

export interface SearchFilters {
  searchTerm: string;
  contentDate?: string | null;
  supplementDateFrom?: string | null;
  supplementDateTo?: string | null;
  supplement?: string | null;
  docket?: string | null;
}

export interface PrintOrEmailRequest {
  itemNumber: string;
  type: string;
  email?: string;
  contentDate?: string;
}

export interface FirstArticles {
  ArticleNumber: string;
  ArticleHeadingNumber: string;
}

export interface SearchPublicationItem {
  id: string;
  name: string;
  type: PublicationType;
}
